import i18next from 'i18next';

const TOO_MANY_REQUESTS_STATUS = 429;
const TOO_MANY_REQUESTS_CODE = 'TooManyRequests';

/**
 * Codes whose raw API message is shown as-is rather than translated.
 */
const PASSTHROUGH_CODES = [
  'AccountBalanceForDeliveryBalanceTooLow',
  'WireWithdrawalFeeCreditNegative',
  'WireWithdrawalFeeCreditGreatherThanWireWithdrawalFee',
  'AvailableForWithdrawalBalanceTooLow',
  'CantDelete2FaPhone',
  'AvailableBalanceTooLow',
];

/**
 * Whether the request was rejected by rate limiting. Matched on status, since a
 * 429 is not guaranteed to carry the Errors envelope.
 */
const isTooManyRequests = (error) =>
  error?.response?.status === TOO_MANY_REQUESTS_STATUS;

/**
 * The API error code a caller can branch on. Reported as TooManyRequests for a
 * rate-limited response even when it carries no envelope.
 */
export const getErrorCodeFromAPIResponse = (error) => {
  const errorCode = error?.response?.data?.Errors?.[0]?.Code;

  if (!errorCode && isTooManyRequests(error)) {
    return TOO_MANY_REQUESTS_CODE;
  }

  return errorCode;
};

/**
 * The raw, untranslated message the API returned, when there is one.
 */
export const getErrorMessageFromAPIResponse = (error) =>
  error?.response?.data?.Errors?.[0]?.Message;

/**
 * Translate a rejected API call into a user-facing message, falling back to
 * apiErrors.SomethingWentWrong. Reads the code through
 * getErrorCodeFromAPIResponse so both agree on one answer per error.
 */
export const rejectErrorCodeHelper = (error) => {
  const errorCode = getErrorCodeFromAPIResponse(error);

  if (PASSTHROUGH_CODES.includes(errorCode)) {
    return getErrorMessageFromAPIResponse(error);
  }

  return errorCode
    ? i18next.t(`apiErrors.${errorCode}`)
    : i18next.t('apiErrors.SomethingWentWrong');
};
